Object.defineProperty(exports, '__esModule', {
  value: true
});
var React = require('react');
var core = require('@material-ui/core');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var useStyles = core.makeStyles(function () {
  return {
    root: {
      marginLeft: 14
    }
  };
});
var ErrorText = function ErrorText(_a) {
  var errorMessage = _a.errorMessage;
  if (!errorMessage) return React__default['default'].createElement(React.Fragment, null);
  var classes = useStyles();
  return React__default['default'].createElement(core.FormHelperText, {
    "data-test": "ds-developer-form-error-text-" + errorMessage,
    className: classes.root,
    error: true
  }, errorMessage);
};
exports.default = ErrorText;